import { css } from '@emotion/react';

import { useSessionStore } from 'session/useSessionStore';

export function SeismicLogoNavbar() {
    const {tenantConfig} = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration
    }));
    const logoPath = tenantConfig?.layout.logoPath;

    if (!logoPath){
        return null;
    }

    return (
        window.location.href.indexOf('skkmigas') === -1 ?
            <img style={{
                backgroundColor: tenantConfig?.layout.backgroundColor ?? 'transparent',
                maxWidth: 130,
                maxHeight: 32,
                marginTop: '-8px !important',
                marginLeft: '10px !important'
            }} src={logoPath} />
            :
            <img style={{
                maxWidth: 130,
                maxHeight: 32,
                marginTop: '-8px !important',
                marginLeft: '10px !important',
                backgroundColor: 'white',
                borderRadius: '5px',
                padding: '5px'
            }} src={logoPath} />
    );
}